document.addEventListener("turbolinks:load", function() {
  $('#right').click(function(){
      $('.ui.segment.attached #flag_direction').val("right");
  });

    $('#left').click(function(){
        $('.ui.segment.attached #flag_direction').val("left");
    });
    setTimeout("$('#oop_search').dropdown({action: 'nothing'})", 1000);

    $('#oop_search input').keyup(function () {
     current_text = $(this).val();
     regexp = new RegExp(current_text, "i");

     $.each(  $('.scrolling.menu .item'), function( key, value ) {
         if($(value).text().search(regexp) == -1){
             $(value).attr("style","display: none;");
         }else{
             $(value).removeAttr("style");
         }
     });
    });

    kind_doc = {3:'Учебный план',4:'Аннотации дисциплин',5:'Приложения к аннотации дисциплин',6:'Рабочая программа дисциплины',8:'Аннотация к практике'};
    var id_op_file;

    $('.op').on('click', function () {
       year = ($(this).attr('data-year')!=""?$(this).attr('data-year') : "nil")  ;
       id_edu_form = ($(this).attr('data-id_edu_form')!=""?$(this).attr('data-id_edu_form') : "nil")  ;
       id_edu_pof = ($(this).attr('data-id_edu_pof')!=""?$(this).attr('data-id_edu_pof') : "nil")  ;
       id_edu_pog = $(this).attr('data-id_edu_pog');
       id_op_file = $(this).attr('data-id_file');

       $.ajax({
           url: '/reference/oops/get_list_files',
           type: 'GET',
           data: {'year': year, 'id_edu_form': id_edu_form,'id_edu_pof': id_edu_pof,'id_edu_pog': id_edu_pog},
           beforeSend: function() {
               $('#dim.ui.dimmer').addClass('active');
               $('.ui.longer.modal tbody').empty();
           },
           success: function(current_hash){
               $.each(kind_doc, function(index_doc, value_doc){

                  id_root = "root_chk_" + index_doc;

                  $('.ui.longer.modal tbody').append('<tr><td class="collapsing"><div class="ui fitted slider checkbox"><input id="' + id_root + '" type="checkbox" tabindex="0" class="hidden"><label></label></div></td><td style="background:#00000008;text-align:center;">'+ value_doc +'</td></tr>');

                  checked_count = 0;
                  all_count = 0;
                  $.each(current_hash, function(index, value){
                      if(value["edu_programm_file_kind_id"]==index_doc){
                          if (value["ligament"] != null && value["op_id"] == id_op_file){
                            current_check = "checked"
                          }else{
                            current_check = ""
                          }

                          $('.ui.longer.modal tbody').append('<tr data-id_file="' + value["id"] + '"><td class="collapsing" style="background:#fff"><div class="ui fitted slider checkbox"><input id="chk_' + index_doc + '_' + index + '" type="checkbox" tabindex="0" class="hidden" ' + current_check + '><label></label></div></td><td><a href="' + window.location.origin + value["url"] + '" target="_blank">' + value["name"] + '</a>' + (value["op_name"] != "" ? " - " : "") + value["op_name"] + '</td></tr>');
                          all_count++;
                          if(value["ligament"] != null){checked_count++;}
                      }
                  });

                  if(checked_count == all_count && all_count != 0){
                      //$('#'+id_root).attr('checked','checked');
                      $('#'+id_root).prop("checked", true);
                  }
               });

               $('#dim.ui.dimmer').removeClass('active');
               $('.longer.modal').modal('show');
               $('.ui.checkbox').checkbox();

               $('[id*="root_chk_"]').change(function(){
                   part_id = $(this).attr('id').substring(5);
                   check = $(this).is(":checked");

                   $.each($(this).parents('tbody').find('[id*="' + part_id + '"]'), function(index, value){
                       if(check){
                           $(value).prop("checked", true);
                       }else{
                           $(value).prop("checked", false);
                       }
                   });
               });


               $('[id*="chk_"]').change(function(){
                   part_id_list = $(this).attr('id').substring(0,5);
                   check_list = $(this).is(":checked");
                   flag = true;


                   if(check_list){
                       $.each($(this).parents('tbody').find('[id^="' + part_id_list + '"]'), function(index, value){
                         if(!$(value).is(":checked")){
                             flag = false;
                             return false;
                         }
                      });

                      if(flag){$('[id*="root_'+ part_id_list +'"]').prop("checked", true);}
                   }else{
                       $('[id*="root_'+ part_id_list +'"]').prop("checked", false);
                   }
               });
           }
       });

    });

    $('#doc_tie').on('click', function(){
        checked_arr = [];

        $.each($('.ui.longer.modal').find('[id^="chk_"]:checked'), function(index, value){
            checked_arr.push($(value).parents('tr').attr('data-id_file'));
        });

        $.ajax({
            url: '/reference/oops/change_list_files',
            type: 'GET',
            data: {'id_op_file': id_op_file,'checked_arr': checked_arr},
            beforeSend: function() {},
            success: function(){}
        });
    });
});